<template>
  <div class="">
    <div>
      <div class="pay-summary">
        <div class="lbl">
          Amount to collect
        </div>
        <div class="amt">
          Rs {{ item?.charge_session?.total_cost || 0 }}
        </div>
        <div class="kwh">
          {{ item?.charge_session?.energy_consumed || 0 }} kWh used ·
          {{ item?.charge_session?.duration_minutes || 0 }} min
        </div>
      </div>
      <div class="pay-methods">
        <div
          :class="['pay-opt', { sel: payment_type === 'cash' }]"
          @click="payment_type = 'cash'"
        >
          <!-- @click="$emit('update:payment_type', 'cash')" -->
          <v-icon large>
            mdi-cash
          </v-icon>
          <div class="nm">
            Cash
          </div>
        </div>
        <div
          :class="['pay-opt', { sel: payment_type === 'card' }]"
          @click="payment_type = 'card'"
        >
          <!-- @click="$emit('update:payment_type', 'card')" -->
          <v-icon large>
            mdi-credit-card
          </v-icon>

          <div class="nm">
            Card / POS
          </div>
        </div>
        <div
          :class="['pay-opt disabled', { sel: payment_type === 'app' }]"
          @click="payment_type = 'app'"
        >
          <!-- @click="$emit('update:payment_type', 'app')" -->
          <v-icon large>
            mdi-cellphone-text
          </v-icon>
          <div class="nm">
            Pay In App
          </div>
        </div>
      </div>
    </div>
    <div>
      <v-btn
        color="primary"
        class="big-btn btn-primary"
        height="4.5rem"
        :loading="loading"
        :disabled="!payment_type"
        @click="onTakePayment"
      >
        Confirm Payment Received
      </v-btn>
      <div class="helper-text">
        Pick how the customer paid
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      payment_type: "",
    };
  },
  methods: {
    async onTakePayment() {
      this.loading = true;
      const params = {
        id: this.item?.booking_id || this.item?.charge_session?.session_id,
        booking_id: this.item?.booking_id,
        session_id: this.item?.charge_session?.session_id,
        payment_type: this.payment_type,
      };
      await this.$store
        .dispatch("bookingOperator/createPayment", params)
        .then(() => {
          this.$emit("click", "booking_completed");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
<style lang="sass" scoped>
.pay-methods .disabled
  pointer-events: none
  background: var(--line)
  i
    color: var(--muted)
</style>
